import { handleActions } from 'redux-actions';

import { resourceStoreTypes, resourceUpserters } from '../core';

import * as actions from './taxLineItemsActions';

const reducer = handleActions(
  {
    [actions.getTaxLineItems]: (state) => state.set('isLoading', true),
    [actions.getTaxLineItemsSuccess]: (state, { payload: data }) => resourceUpserters.upsertResources(state, data),
    [actions.getTaxLineItemsFailure]: (state, { payload: error }) => resourceUpserters.completeWithError(state, error),
  },
  resourceStoreTypes.mkQcsSyncResourceStore(),
);

export default reducer;
